import { render, staticRenderFns } from "./SidelightInfo.vue?vue&type=template&id=37f26705&"
import script from "./SidelightInfo.vue?vue&type=script&lang=js&"
export * from "./SidelightInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports